export default "__VITE_ASSET__r9vd_F4w__"